import { useQuery } from "@tanstack/react-query";
import { fetchItemsCount } from "directus/src/operations";

export function useCount({
  endpoint,
  filters,
  fields = ["id"],
  fetchCount = fetchItemsCount,
}) {
  const queryKey = [endpoint, "count", { filters, fields }];
  const { data, isLoading } = useQuery({
    queryKey,
    enabled: !!endpoint,
    queryFn: async () => {
      const res = await fetchCount(endpoint, {
        aggregate: { countDistinct: ["id"] },
        query: { filter: filters || {} },
      });
      return res?.[0]?.countDistinct?.id ?? 0;
    },
  });
  return { count: data ?? 0, isLoading };
}
